/**
 * Rental Agreement Page
 *
 * CMS-managed rental agreement with hardcoded fallback content.
 */

import { LegalPage } from '@/components/LegalPage';
import { DEFAULT_RENTAL_AGREEMENT } from '../defaults/rentalAgreementDefaults';

export const RentalAgreementPage = () => (
    <LegalPage
        pageSlug="rental-agreement"
        title="Rental Agreement"
        metaDescription="Rental Agreement for Stork Rentals baby equipment rental service - equipment care, deposits, returns, and liability."
        defaults={DEFAULT_RENTAL_AGREEMENT}
    />
);

export default RentalAgreementPage;
